import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import React, { useEffect, useState } from "react";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import "../TGases.css";
import { plotBackground } from "../../../config/colors";

export default function PerfilHESP() {
  const [tensionCampo1, setTensionCampo1] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [tensionCampo2, setTensionCampo2] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [tensionCampo3, setTensionCampo3] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [tensionCampo4, setTensionCampo4] = useState({
    value: [],
    fecha: [],
    estado: [],
  });


  // Fecha inicial y final
  const [date, setDate] = useState({ start: "19-01-2023", end: "25-01-2023" });

  // Objeto inicial de la peticion
  const initialFetch = {
    idSeccion: 3,
    secuencia: 15,
    ultimo: 0,
    frecuencia: 5,
    dias: 7,
  };

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
    const { data } = await getValoresPeriodo(initialFetch);

    populateTensionCampo1(data);
    populateTensionCampo2(data);
    populateTensionCampo3(data);
    populateTensionCampo4(data);

      //#endregion
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateTensionCampo1(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Tensión Campo 1 HESP"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setTensionCampo1({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateTensionCampo2(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Tensión Campo 2 HESP"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setTensionCampo2({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateTensionCampo3(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Tensión Campo 3 HESP"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setTensionCampo3({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateTensionCampo4(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Tensión Campo 4 HESP"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setTensionCampo4({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  return (
    <>
       <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Perfil Tensión HESP"}
            subtitle={"Periodo " + date.start + " - " + date.end}
          >
            {/** -------------------------------- Tensión Campo 1 HESP --------------------------------------- */}
            <Chart.Line
              name="Tensión Campo 1 HESP"
              data={tensionCampo1.value}
              yAxis={0}
            />
            {/** -------------------------------- Tensión Campo 2 HESP --------------------------------------- */}
            <Chart.Line
              name="Tensión Campo 2 HESP"
              data={tensionCampo2.value}
              yAxis={0}
            />
            {/** -------------------------------- Tensión Campo 3 HESP --------------------------------------- */}
            <Chart.Line
              name="Tensión Campo 3 HESP"
              data={tensionCampo3.value}
              yAxis={0}
            />
            {/** -------------------------------- Tensión Campo 4 HESP --------------------------------------- */}
            <Chart.Line
              name="Tensión Campo 4 HESP"
              data={tensionCampo4.value}
              yAxis={0}
            />

            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={tensionCampo1.fecha} />

            <Chart.YAxis
              labelSuffix=" kV"
              title="Tensión, kV"
              lineWidth={2}
              lineColor="white"
            />

            <Chart.YAxis
              labelSuffix=""
              title=""
              lineWidth={2}
              opposite={true}
              lineColor="white"
            />

            <Chart.Tooltip valueSuffix="" />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
